const PauseIcon = ({ width = "22px", fill }) => {
    return (
        <svg x="0px" y="0px" viewBox="0 0 25.2 25.2" xmlSpace="preserve" width={width} fill={fill}>
            <rect x="4.2" y="1.1"  width="6.1" height="23.1" fill={fill}/>
	        <rect x="14.9" y="1.1" width="6.1" height="23.1" fill={fill}/>
        </svg>
    );
};

export default PauseIcon;